<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Visão geral" subTitle="Perfil do usuário" />

    <!-- Content -->
    <user-account-details :isCurrentUser="true" ref="userForm"/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import { CloneDeep } from '_utils';
import SessionService from '_services/common/sessionService';
import UserAccountDetails from '_modules/user/components/UserAccountDetails.vue';
import { _LOAD_MODEL_, MODEL } from '_modules/user/components/UserModel';

export default {
  name: 'user-profile-lite',
  components: {
    PageHeader,
    UserAccountDetails,
  },
  data() {
    return {};
  },
  methods: {
  },
  mounted() {
    const user = Object.assign(CloneDeep(MODEL), SessionService.getLocalData('_user'));
    if (!user.settings.image.url_image) {
      user.settings.image.url_image = require('@/assets/images/avatars/enhanced-buzz.jpeg');
    }
    Events.$emit(_LOAD_MODEL_, Object.assign(user));
  },
};
</script>

